import React from 'react';
import {
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

const styles = {
  root: {
    marginTop: 20,
  },
  textField: {
    marginBottom: '4px',
  },
};

const SqlConnectionForm = ({
  connectionInfo,
  handleDeleteConnection,
  handleSaveConnection,
  handleUpdateConnection,
  setConnectionInfo,
  selectedSQLConnection,
}) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    setConnectionInfo((prevConnectionInfo) => ({
      ...prevConnectionInfo,
      [name]: value,
    }));
  };

  const handleCheckbox = () => {
    setConnectionInfo({
      ...connectionInfo,
      setDefault: !connectionInfo.setDefault,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Add form validation logic here
    if (
      connectionInfo.title.trim() === '' ||
      connectionInfo.host.trim() === '' ||
      connectionInfo.username.trim() === '' ||
      (!connectionInfo.airSyncSQLConnectionId &&
        connectionInfo.password.trim() === '') ||
      connectionInfo.database.trim() === ''
    ) {
      alert('Please fill in all required fields.');
      return;
    }
    if (selectedSQLConnection === 0) {
      handleSaveConnection();
    } else {
      handleUpdateConnection();
    }
  };
  return (
    <div style={styles.root}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              style={styles.textField}
              label='Title'
              fullWidth
              name='title'
              value={connectionInfo.title}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              style={styles.textField}
              label='Host'
              fullWidth
              name='host'
              value={connectionInfo.host}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              style={styles.textField}
              label='Username'
              fullWidth
              name='username'
              autoComplete={false}
              value={connectionInfo.username}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              style={styles.textField}
              label='Password'
              fullWidth
              autoComplete={false}
              name='password'
              type='password'
              value={connectionInfo.password}
              onChange={handleChange}
              required={connectionInfo.airSyncSQLConnectionId ? false : true}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              style={styles.textField}
              label='Database'
              fullWidth
              name='database'
              value={connectionInfo.database}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid container item justifyContent='space-between' xs={12}>
            <Grid>
              <Button variant='outlined' color='primary' type='submit'>
                Save
              </Button>
              <Button
                disabled={selectedSQLConnection === 0}
                style={{ marginLeft: 8 }}
                variant='outlined'
                color='error'
                onClick={handleDeleteConnection}
              >
                Delete
              </Button>
            </Grid>
            <Grid>
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    checked={connectionInfo.setDefault}
                    onChange={handleCheckbox}
                  />
                }
                label='Set as Default'
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default SqlConnectionForm;
